/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Select,
} from "antd";
import { DELETE_USER, EDIT_USER, STAFF } from "../../constants/api";
import {
  ACTIVE_INACTIVE_OPTION,
  getUserTypeLabel,
  isSuperAdmin,
} from "../../constants/constent";

function UserTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getData();
  }, []);

  const updateData = (values) => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
      getData();
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_USER, values, successFn, errorFn);
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Type: getUserTypeLabel(row.user_type),
          Name: row.name,
          Email: row.email,
          Phone: row.phone,
          Action: (
            <Space>
              <Select
                disabled={row.user_type !== "bde"}
                options={ACTIVE_INACTIVE_OPTION}
                value={row.status}
                onChange={(value) => {
                  updateData({
                    ...row,
                    id: row.id,
                    status: value,
                  });
                }}
              />
              <Button
                disabled={row.user_type === "vendor"}
                onClick={() => {
                  navigate("/user/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              {isSuperAdmin() ? (
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  onConfirm={() => deleteData(row.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button disabled={row.user_type === "vendor"} danger>
                    Delete
                  </Button>
                </Popconfirm>
              ) : null}
            </Space>
          ),
        }));

        // Filter user types based on current user role
        const filteredUserTypes = isSuperAdmin()
          ? formattedData
          : formattedData.filter(
              (type) => type.Type !== "Super Admin" && type.Type !== "Admin",
            );

        setState(filteredUserTypes);
        setFilteredState(filteredUserTypes);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(STAFF, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = { id: values };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_USER, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (user) =>
        user.Type.toLowerCase().includes(value.toLowerCase()) ||
        user.Name.toLowerCase().includes(value.toLowerCase()) ||
        user.Email.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredState(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Role",
      dataIndex: "Type",
      width: 150,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "Email",
      width: 50,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Staff"
            extra={
              <Space>
                <Input
                  placeholder="Search by Role, Name or Email"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/user/add")}>
                  Add <PlusOutlined />
                </Button>
                <Button
                  ghost
                  type="primary"
                  loading={loading}
                  onClick={getData}
                >
                  <ReloadOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredState}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default UserTable;
